export default "__VITE_ASSET__406e8cf4__"